import React from "react";
import "animate.css";

function Sapintegration() {
  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb5">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            SAP Integration Services
          </h4>
        </div>
      </div>

      {/* Main Content Start */}
      <div className="container py-5">
        <section className="wow fadeInUp" data-wow-delay="0.2s">
          <div className="row align-items-center g-5">
            {/* Image Section */}
            <div className="col-lg-6 col-md-12">
              <img
                src="assets/img/sapIntegration.png"
                alt="SAP Integration Services"
                className="img-fluid rounded-4 shadow-lg"
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* Text Section */}
            <div className="col-lg-6 col-md-12">
              <div className="section-title">
                <h2 className="fw-bold text-primary mb-3">Seamless Fusion</h2>
                <p>
                  Our <strong>SAP Integration Services</strong> help organizations
                  connect various systems, applications, and data sources to SAP to
                  create a unified and streamlined system environment. With our
                  service, your organization can gain the following:
                </p>
                <ul className="list-unstyled ms-3">
                  <li> Real-Time Data Access between SAP and other systems</li>
                  <li> Elimination of manual data entry into SAP</li>
                  <li> Reduction in duplicate data maintenance</li>
                  <li> Seamless Business Processes across systems</li>
                  <li> Use of emerging technologies in SAP</li>
                  <li> Optimized Supply Chain Management</li>
                </ul>
                <p className="mt-3">
                  Our SAP integration services offer a wide range of benefits that
                  contribute to increased efficiency, better decision-making, enhanced
                  customer experiences, and overall business success. It plays a
                  crucial role in modernizing and optimizing organizational processes
                  in today's interconnected business landscape.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Mobile Image Adjustment */}
      <style>
        {`
          @media (max-width: 768px) {
            img[alt="SAP Integration Services"] {
              max-height: 350px !important;
            }
          }
        `}
      </style>

      {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p>
                <span style={{ fontSize: 20 }}>
                  <em>
                    <strong>USA</strong>
                  </em>
                </span>
              </p>
              <p>
                <i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd{" "}
                <br /> Ste 355 Houston, TX 77077
              </p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p>
                <em>
                  <span style={{ fontSize: 20 }}>
                    <strong>CANADA</strong>
                  </span>
                </em>
              </p>
              <p>
                <i className="fas fa-map-marker me-1" /> 998 Loft Court, London,
                Ontario, N6G0J9
              </p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p>
                <span style={{ fontSize: 20 }}>
                  <em>
                    <strong>INDIA</strong>
                  </em>
                </span>
              </p>
              <p>
                <i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun
                Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085
              </p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com">
                  <i className="fas fa-envelope me-2" /> info@celersoft.com
                </a>
                <a href="tel:+18322258898">
                  <i className="fas fa-phone me-2" /> (+1) 832-225-8898
                </a>
                <hr />
                <div className="d-flex align-items-center">
                  <a
                    className="btn btn-light btn-md-square me-2"
                    href="https://www.facebook.com/celersoft"
                  >
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a
                    className="btn btn-light btn-md-square me-0"
                    href="https://www.linkedin.com/company/celersoft/"
                  >
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>
    </>
  );
}

export default Sapintegration;
